import { createSlice, nanoid } from "@reduxjs/toolkit";
import { logout } from "../../auth/authSlice";
import { getRiskRequestKey } from "../../../../utils/diseaseRiskUtils";

const emptyCurrent = { request: null, key: null, status: "idle", data: null, error: null };
const initialState = { ...emptyCurrent, cache: {} };

const diseaseRiskSlice = createSlice({
  name: "diseaseRisk",
  initialState,
  reducers: {
    fetchDiseaseRiskStart: {
      prepare: (payload) => ({ payload: { ...payload, key: getRiskRequestKey(payload), requestId: nanoid() } }),
      reducer(state, { payload }) {
        Object.assign(state, emptyCurrent, { request: payload, key: payload.key, status: "loading" });
      },
    },
    fetchDiseaseRiskSuccess(state, { payload }) {
      if (state.request?.requestId !== payload.requestId) return;
      state.data = payload.data;
      state.status = payload.data.assessments.length ? "ready" : "empty";
      state.error = null;
      state.cache[state.key] = payload.data;
    },
    fetchDiseaseRiskFailure(state, { payload }) {
      if (state.request?.requestId !== payload.requestId) return;
      state.status = "error";
      state.error = payload.error;
    },
    cancelDiseaseRisk(state) { Object.assign(state, emptyCurrent); },
  },
  extraReducers: (builder) => builder.addCase(logout, () => initialState),
});

export const { fetchDiseaseRiskStart, fetchDiseaseRiskSuccess, fetchDiseaseRiskFailure, cancelDiseaseRisk } = diseaseRiskSlice.actions;
export default diseaseRiskSlice.reducer;
